import { Column, Element, Icon, Row } from '@vuddy/components';
import * as styles from './buttonGroupProxyItem.css';

interface IGachaButtonGroupProxyItemProps {
  count: number;
  onClick: VoidFunction;
}

export const GachaButtonGroupProxyItem = ({
  count,
  onClick,
}: IGachaButtonGroupProxyItemProps) => {
  return (
    <Column className={styles.wrapper} width="100%">
      <button className={styles.button} type="button" onClick={onClick}>
        <Row gap="gap_xs" alignItems="center" justifyContent="center">
          <Icon name="FILL_TICKET" color="primary" size="16px" />
          <Element
            typography="bodyBaseAccent"
            color="primary"
            className={styles.text}>
            보유중인 가챠권 {count}개 사용하기
          </Element>
          <Icon name="OUTLINE_CHEVRON_RIGHT" color="primary" size="16px" />
        </Row>
      </button>
    </Column>
  );
};
